import { AccomodationEnum } from '../../lib/types/enums/accomodation-type/accomodation-type'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getCenterAccomodation(id: number) {
  return restApiClient
    .url(constructApiUrl(API.centers.getCenterAccomodation.url, { id }))
    .get<{ accomodation: AccomodationEnum }>()
}
